import ToastSuccess from '@atoms/ToastSuccess';
import dynamicLinks from '@react-native-firebase/dynamic-links';
import AmplitudeHelper from '@utils/analytics';
import { AMPLITUDE_CONSTANTS } from '@utils/analytics/constants';
import * as Clipboard from 'expo-clipboard';
import React from 'react';
import { Share } from 'react-native';

async function buildLink(code) {
  return dynamicLinks().buildShortLink(
    {
      link: `https://gajigesanative.page.link/referral/${code}`,
      // domainUriPrefix is created in your Firebase console
      domainUriPrefix: 'https://gajigesanative.page.link',
      ios: {
        bundleId: 'org.reactjs.native.example.GajiGesaNative',
        customScheme: 'com.googleusercontent.apps.959826625148-n033p2bufr42l3nr9aki29hql01r4cn1',
        fallbackUrl: 'https://app.gajigesa.com',
      },
      android: {
        packageName: 'com.gajigesanative',
      },
      navigation: {
        forcedRedirectEnabled: true,
      },
    },
    'SHORT',
  );
}

const generateCodeShortLink = async code => buildLink(code);

export default generateCodeShortLink;

export function onEarnedReferralComplete(setEarnedPoints) {
  return data => {
    setEarnedPoints(data?.points_txn_aggregate?.aggregate?.sum?.value || 0);
  };
}

export function referralPageHandlers(setCollapsedUsage, collapsedUsage, referralCode, toast, t, referralData) {
  const onPressDropDown = () => {
    setCollapsedUsage(!collapsedUsage);
    AmplitudeHelper.logEvent(AMPLITUDE_CONSTANTS.Referral.Dropdown.name, {
      [AMPLITUDE_CONSTANTS.Referral.Dropdown.attributes.action]: collapsedUsage ? 'collapse' : 'expand',
    });
  };

  const onCopyToClipBoard = async () => {
    try {
      const clipBoardValue = await Clipboard.setStringAsync(referralCode);
      if (clipBoardValue) {
        toast.show({
          render: () => <ToastSuccess data={t('referral.codeCopiedSuccessfully')} />,
          placement: 'top',
        });
        AmplitudeHelper.logEvent(AMPLITUDE_CONSTANTS.Referral.CopySuccess.name, {
          [AMPLITUDE_CONSTANTS.Referral.CopySuccess.attributes.referral_code]: referralCode || null,
        });
      }
    } catch (e) {
      AmplitudeHelper.logEvent(AMPLITUDE_CONSTANTS.Referral.CopyFailed.name, {
        [AMPLITUDE_CONSTANTS.Referral.CopyFailed.attributes.referral_code]: referralCode || null,
        [AMPLITUDE_CONSTANTS.Referral.CopyFailed.attributes.failure_message]: 'system_error',
      });
    }
  };

  const shareShortLinkCallBack = async shortLink => {
    try {
      AmplitudeHelper.logEvent(AMPLITUDE_CONSTANTS.Referral.Share.name, {
        [AMPLITUDE_CONSTANTS.Referral.Share.attributes.referral_code]: referralCode || null,
      });
      const result = await Share.share({
        message: `${t('referral.txtGift')} ${referralData?.referrerRewardAmount} ${t(
          'referral.txtPoinShare',
        )} ${referralCode} \n\n ${t('referral.txtDownloadApp')}:\n ${shortLink} *${t('referral.txtTnCPoins')}`,
      });
      if (result.action === Share.sharedAction) AmplitudeHelper.logEvent(AMPLITUDE_CONSTANTS.Referral.Select.name);
    } catch (error) {
      /* empty */
    }
  };
  return { shareShortLinkCallBack, onPressDropDown, onCopyToClipBoard };
}
